import cmp from './AuthLayout'

export default cmp
